<!-- Modals -->
<app-deprecated-confirmation-dialog
    #confirmDeleteApplicantMessageTemplateDialog
    [label]="'applicant-tracker.delete'"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<div class="page-container">
    <app-header title="applicant-tracker.emailTemplates" [menuService]="recruitingModuleMenuService">
        <div class="buttons">
            <ui-button
                [routerLink]="['/', 'recruiting', 'templates', 'applicantMessageTemplates', 'create']"
                type="primary"
            >
                <mat-icon svgIcon="plus" aria-hidden="true"></mat-icon>
                <span>{{ 'applicant-tracker.createTemplate' | translate }}</span>
            </ui-button>
        </div>
    </app-header>

    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table
            [table]="table"
            (menuItemSelected)="menuAction($event)"
            [isResponsive]="true"
            [showOffset]="true"
            [noPadding]="true"
            [embedded]="true"
        >
            <div class="empty">
                <img style="max-width: 30%" src="/assets/illustrations/documents.png" />
                <h2 class="ui centered header">{{ 'applicant-tracker.noEmailTemplatesFound' | translate }}</h2>
            </div>
        </app-table>
    </ui-card>
</div>
